import type { BadgeProps } from '@wartek-id/badge'
import { Badge } from '@wartek-id/badge'
import { Button } from '@wartek-id/button-v1'

import type {
  PelaksanaanState,
  PelaksanaanStateFilter,
  RealisasiSkp,
} from 'types/kinerja-ks-pelaksanaan'

export const pelaksanaanStateLabel = (
  status?: PelaksanaanStateFilter,
  fallback: string = 'Semua'
) => {
  if (!status) return fallback

  let label = fallback

  switch (status) {
    case 'ALL':
      label = fallback
      break

    case 'PREPARATION':
    case 'OBSERVATION':
      label = 'Rating observasi'
      break

    case 'FOLLOW_UP':
    case 'FOLLOW_UP_EVALUATION':
      label = 'Nilai tindak lanjut'
      break

    case 'REFLECTION_FOLLOW_UP':
    case 'REFLECTION_FOLLOW_UP_EVALUATION':
      label = 'Nilai refleksi tindak lanjut'
      break

    case 'COMPLETED':
      label = 'Sudah selesai'
  }

  return label
}

export const rhkStateLabel = (state: RealisasiSkp['state']) => {
  switch (state) {
    case 'EVALUATED':
    case 'WAITING_EVALUATION':
      return 'Sudah dikumpulkan'

    case 'DRAFT':
      return 'Lanjutkan draf'

    case 'PENDING_SUBMISSION':
    default:
      return 'Belum dikumpulkan'
  }
}

export const rhkStateBadge = (state: RealisasiSkp['state']) => {
  let badgeVariant: BadgeProps['variant']

  switch (state) {
    case 'EVALUATED':
    case 'WAITING_EVALUATION':
      badgeVariant = 'success'
      break

    case 'DRAFT':
      badgeVariant = 'warning'
      break

    case 'PENDING_SUBMISSION':
    default:
      badgeVariant = 'critical'
      break
  }

  return <Badge variant={badgeVariant}>{rhkStateLabel(state)}</Badge>
}

export const rhkStateCta = (state: RealisasiSkp['state']) => {
  switch (state) {
    case 'EVALUATED':
      return (
        <Button size="sm" color="white">
          Cek
        </Button>
      )

    case 'WAITING_EVALUATION':
      return (
        <Button size="sm" color="white">
          Ubah
        </Button>
      )

    case 'DRAFT':
      return (
        <Button size="sm" color="black">
          Lanjutkan
        </Button>
      )

    case 'PENDING_SUBMISSION':
    default:
      return (
        <Button size="sm" color="black">
          Kumpulkan
        </Button>
      )
  }
}

export const pelaksanaanStateKey = (
  status?: PelaksanaanStateFilter
): string => {
  const mapped = {
    ALL: 'all',
    PREPARATION: 'preparation',
    OBSERVATION: 'observation',
    FOLLOW_UP: 'followUp',
    FOLLOW_UP_EVALUATION: 'followUpEvaluation',
    REFLECTION_FOLLOW_UP: 'reflectionFollowUp',
    REFLECTION_FOLLOW_UP_EVALUATION: 'reflectionFollowUpEvaluation',
    COMPLETED: 'completed',
  }

  return mapped?.[status]
}

export const getStepsToResetInPreparationState = (
  pelaksanaanState: PelaksanaanState
) => {
  const showDokumenRefleksiTindakLanjut =
    pelaksanaanState === 'REFLECTION_FOLLOW_UP_EVALUATION' ||
    pelaksanaanState === 'COMPLETED'
  const showDokumenTindakLanjut =
    pelaksanaanState === 'FOLLOW_UP_EVALUATION' ||
    pelaksanaanState === 'REFLECTION_FOLLOW_UP' ||
    showDokumenRefleksiTindakLanjut
  const showDokumenRatingObservasi =
    pelaksanaanState === 'FOLLOW_UP' || showDokumenTindakLanjut

  const stepsToReset: PelaksanaanState[] = ['PREPARATION']
  if (showDokumenRatingObservasi) stepsToReset.push('OBSERVATION')
  if (showDokumenTindakLanjut) stepsToReset.push('FOLLOW_UP')
  if (showDokumenRefleksiTindakLanjut) stepsToReset.push('REFLECTION_FOLLOW_UP')

  return stepsToReset
}
